import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defaultContents: {
    description: 'customs.widget.defaultContents',
    defaultMessage: 'Select Contents',
    id: 'fxf8Bo',
  },
  contentsLabel: {
    description: 'customs.widget.contentsLabel',
    defaultMessage: 'Select Contents',
    id: '85nXFi',
  },
  dutiesPaidLabel: {
    description: 'customs.widget.dutiesPaidLabel',
    defaultMessage: 'Duties Paid',
    id: '0RcQ8B',
  },
  postagePaidLabel: {
    description: 'customs.widget.postagePaidLabel',
    defaultMessage: 'Postage Paid',
    id: 'z4zDPM',
  },
  defaultNonDelivery: {
    description: 'customs.widget.defaultNonDelivery',
    defaultMessage: 'Select Non-Delivery',
    id: 'G5MTu1',
  },
  nonDeliveryLabel: {
    description: 'customs.widget.nonDeliveryLabel',
    defaultMessage: 'If Undeliverable',
    id: 'FIQBGj',
  },
  uspsExemptionLabel: {
    description: 'customs.widget.exemptionLabel',
    defaultMessage: 'USPS Exemption',
    id: 'w/g3Y+',
  },
  itnLabel: {
    description: 'customs.widget.itnLabel',
    defaultMessage: 'ITN',
    id: 'z9FCuM',
  },
  itnOrExemptionLabel: {
    description: 'label for read only customs itn or exemption info',
    defaultMessage: 'ITN/AES',
    id: 'YHUdKH',
  },
  missingItnWarning: {
    description: 'customs.widget.itnWarning',
    defaultMessage: 'ITN may be required for this shipment. <a>Learn more</a>',
    id: 'QnuhKL',
  },
  missingExemptionWarning: {
    description: 'customs.widget.exemptionWarning',
    defaultMessage: 'AES Exemption Code may be required for this shipment. <a>Learn more</a>',
    id: 'DfWeOX',
  },
  iorLabel: {
    description: 'Label to Importer of Record dropdown in customs widget',
    defaultMessage: 'IOR information',
    id: 'zvpHv/',
  },
  taxIdentifiers: {
    description: 'tax identifiers label',
    defaultMessage: 'Tax Identifiers',
    id: 'ydarvG',
  },
  taxIdentifiersTooltip: {
    description: 'Tooltip for tax identifiers label',
    defaultMessage: 'Tax registration numbers recommended for imports to certain countries.',
    id: 'Lj58Yf',
  },
  declarationHeader: {
    description: 'customs.widget.declarationHeader',
    defaultMessage: 'Declaration {declaredCount}',
    id: '4BSEuJ',
  },
  delete: {
    description: 'customs.widget.delete',
    defaultMessage: 'Delete',
    id: 'lE9bYr',
  },
  descriptionLabel: {
    description: 'customs.widget.descriptionLabel',
    defaultMessage: 'Description',
    id: 'LajQcB',
  },
  descriptionHelperText: {
    description: 'Helper text for customs item description input',
    defaultMessage: 'Avoid vague terms like "gift" or "sample". Best practice: Include material, use, and key features.',
    id: 'DXJxCO',
  },
  weightLabel: {
    description: 'customs.widget.weightLabel',
    defaultMessage: 'Item Weight',
    id: '9whlnq',
  },
  skuLabel: {
    description: 'customs widget abbreviated label for Stock Keeping Unit/SKU',
    defaultMessage: 'SKU',
    id: 'QGOvcp',
  },
  midLabel: {
    description: 'customs widget label for Manufacturer Identification code',
    defaultMessage: 'MID code',
    id: 'kgI5dz',
  },
  skuEuTooltip: {
    description: 'customs widget tooltip for the SKU field on non-EU to EU shipments (EU Merchant Product ID)',
    defaultMessage: 'For EU customs: Merchant Product ID',
    id: 'AWBUIG',
  },
  nsManufacturerProductIdLabel: {
    description: 'customs widget label for the Non-Standardized Manufacturer Product ID (MPID) field',
    defaultMessage: 'Manufacturer Product Identification Code',
    id: 'g+q2g5',
  },
  nsManufacturerProductIdTooltip: {
    description: 'customs widget tooltip for the Non-Standardized Manufacturer Product ID (MPID) field',
    defaultMessage:
      "The manufacturer's own model or part number for this specific product. Non-Standardized MPID required for EU customs product identification.",
    id: '1q2y+q',
  },
  manufacturerProductIdLabel: {
    description: 'customs widget label for the Barcode (standardized manufacturer product ID) field',
    defaultMessage: 'Barcode (UPC, ISBN, GTIN, etc.)',
    id: 'i9rhbf',
  },
  manufacturerProductIdTooltip: {
    description: 'customs widget tooltip for the Barcode (standardized manufacturer product ID) field',
    defaultMessage: 'Standardized Manufacturer Product ID',
    id: '5Jf9a3',
  },
  certificateVersionIdLabel: {
    description: 'customs widget label for CPSC Certificate Version ID',
    defaultMessage: 'Certificate Version ID',
    id: '8e2HJ/',
  },
  certifierIdLabel: {
    description: 'customs widget label for CPSC Certifier ID',
    defaultMessage: 'Certifier ID',
    id: 'sHJvLl',
  },
  countryOfOriginLabel: {
    description: 'customs.widget.countryOfOriginLabel',
    defaultMessage: 'Country of Origin',
    id: 'dc42tP',
  },
  quantityLabel: {
    description: 'customs.widget.quantityLabel',
    defaultMessage: 'Quantity',
    id: 's1nDsL',
  },
  itemValueLabel: {
    description: 'customs.widget.itemValueLabel',
    defaultMessage: 'Item Value(ea)',
    id: 'ifIMou',
  },
  itemValueHelperText: {
    description: 'Helper text for customs item value input',
    defaultMessage: 'Undervaluing can result in penalties and shipment delays.',
    id: 'Ig3mOC',
  },
  totalValueLabel: {
    description: 'customs.widget.totalValueLabel',
    defaultMessage: 'Total Value',
    id: 'Q9nilB',
  },
  totalValueTooltip: {
    description: 'Tooltip for total value in customs declaration',
    defaultMessage: 'Automatically calculated: Quantity × Item Value. This is the total declared value.',
    id: 'R3Feqp',
  },
  harmonizationLabel: {
    description: 'Label for customs item harmonization code input',
    defaultMessage: 'Harmonization System (HS) Code',
    id: 'zowxj9',
  },
  harmonizationTooltip: {
    description: 'customs.widget.harmonizationTooltip',
    defaultMessage: 'Required for international UPS, FedEx and DHL Express shipments. Ensures correct duties and taxes are applied.',
    id: 'Bzupzh',
  },
  harmonizationHelperTooltip: {
    description: 'customs.widget.harmonizationHelperTooltip',
    defaultMessage: 'International tariff classification code that identifies the product type.',
    id: 'sMLLW2',
  },
  harmonizationCodePrefilledTooltip: {
    description: 'Tooltip for when harmonization code is pre-filled based on item description',
    defaultMessage: 'This HS code was automatically filled based on the item description from the marketplace.',
    id: 'oUa2i8',
  },
  generateHarmonizationCode: {
    description: 'customs.widget.generateHarmonizationCode',
    defaultMessage: 'Generate harmonization code from description',
    id: '9zbmXP',
  },
  harmonizationDescriptionRequired: {
    description: 'customs.widget.harmonizationDescriptionRequired',
    defaultMessage: 'Description is required to generate harmonization code',
    id: 'LKdt5u',
  },
  harmonizationCodeAlreadyFilled: {
    description: 'customs.widget.harmonizationCodeAlreadyFilled',
    defaultMessage: 'Harmonization code is already filled',
    id: 'XVvt0s',
  },
  hsCodeInsufficientDescriptionError: {
    description: 'Error message when product description is missing or insufficient for HS code lookup',
    defaultMessage: 'Please provide a more detailed product description.',
    id: 'jUbVK7',
  },
  hsCodeGeneralError: {
    description:
      'Error message for general errors during HS code lookup including service unavailable, internal errors, access denied, invalid codes, and unknown errors',
    defaultMessage: 'An error occurred. Please try again or contact support.',
    id: '8PNPOT',
  },
  harmonizationDescriptionLabel: {
    description: 'Label prefix for harmonization code description',
    defaultMessage: 'HS code description: {description}',
    id: '4JGXK+',
  },
  findHSCodeButton: {
    description: 'Label for button to find HS code based on item description',
    defaultMessage: 'Find HS Code',
    id: 'shtcPe',
  },
  addDeclarationLabel: {
    description: 'customs.widget.addDeclarationLabel',
    defaultMessage: 'Add Declaration',
    id: 'r90EMx',
  },
  countryOfOriginDefault: {
    description: 'customs.widget.countryOfOriginDefault',
    defaultMessage: 'Select Country of Origin',
    id: 'mIxbWw',
  },
  headerErrorIndicator: {
    description: 'customs.widget.headerErrorIndicator',
    defaultMessage: 'Fill out all required fields to continue.',
    id: 'TirxSG',
  },
  unknownCountry: {
    description: 'countryNameContainer.unknownCountry',
    defaultMessage: 'Unknown Country',
    id: '/Dekoh',
  },
  savingFPTaxIdentifiers: {
    description: 'Saving fulfillment plan tax identifier',
    defaultMessage: 'Saving...',
    id: 'JkEWds',
  },
  loadingFPTaxIdentifiers: {
    description: 'Loading fulfillment plan tax identifier',
    defaultMessage: 'Loading...',
    id: 'JOJz3T',
  },
  addFirstFPTaxIdentifiers: {
    description: 'Add first fulfillment plan tax identifier',
    defaultMessage: 'Select a Tax Identifier...',
    id: 'YR4YOe',
  },
  addOtherFPTaxIdentifiers: {
    description: 'Add another fulfillment plan tax identifier',
    defaultMessage: 'Add another Tax Identifier...',
    id: 'A5E/r8',
  },
  noSellerTaxIdentifiersSet: {
    description: 'No tax identifiers set go to setting CTA',
    defaultMessage: 'To update orders with Tax Identifiers, add and configure Tax Identifiers on the <a>International Settings Page</a>.',
    id: '/PYwDa',
  },
  taxIDsLabel: {
    description: 'Label for tax ids shown in the read only customs declaration widget',
    defaultMessage: 'Tax IDs',
    id: 'osPAEu',
  },
  exportDeclarationNumber: {
    description: 'Export declaration number label',
    defaultMessage: 'Export Declaration Number',
    id: 'S9YOUL',
  },
  exportDeclarationNumberTooltip: {
    description: 'Tooltip for export declaration number label',
    defaultMessage: 'Export license or declaration number issued by customs; recommended for restricted or high-value shipments.',
    id: 'PFcrZa',
  },
  invoiceNumber: {
    description: 'Invoice number label',
    defaultMessage: 'Invoice Number',
    id: 'LwdUr8',
  },
  recommendedIndicator: {
    description: 'Recommended indicator label',
    defaultMessage: '(Recommended)',
    id: 'n4VZxH',
  },
});
